import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { UiTranslateModule } from '@fcom/ui-translate/ui-translate.module';

import { IconsModule } from '../icons/icons.module';
import { ExpandModule } from '../expand/expand.module';
import { SidebarNavComponent } from './sidebar-nav.component';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';

@NgModule({
  declarations: [SidebarNavComponent, SidebarItemComponent],
  imports: [CommonModule, IconsModule, DirectiveModule, GtmModule, ExpandModule, UiTranslateModule],
  exports: [SidebarNavComponent, SidebarItemComponent],
})
export class SidebarNavModule {}
